export const CUSTOMER_AUTH_SESSION_EXPIRED_EVENT =
  'amitable:customer-auth-session-expired'

export function notifyCustomerAuthSessionExpired(): void {
  if (typeof window === 'undefined') return

  window.dispatchEvent(new Event(CUSTOMER_AUTH_SESSION_EXPIRED_EVENT))
}

export function isCustomerAuthError(error: unknown): boolean {
  return inspectAuthError(error, new Set())
}

function inspectAuthError(value: unknown, seen: Set<object>): boolean {
  if (typeof value === 'string') {
    const normalizedValue = value.toLowerCase()

    return (
      normalizedValue.includes('customer_session_required') ||
      normalizedValue.includes('unauthenticated')
    )
  }

  if (!value || typeof value !== 'object') return false
  if (seen.has(value)) return false
  seen.add(value)

  if (Array.isArray(value)) {
    return value.some((part) => inspectAuthError(part, seen))
  }

  const candidate = value as Record<string, unknown>
  const status = candidate.status ?? candidate.statusCode

  if (status === 401) return true

  return [
    candidate.message,
    candidate.code,
    candidate.extensions,
    candidate.errors,
    candidate.graphQLErrors,
    candidate.networkError,
  ].some((part) => inspectAuthError(part, seen))
}
